import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { SupplierAvailabilityDashboardComponent } from './supplier-availability-dashboard.component';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { VMEComponentsModule } from '../../vme-components.module';

const routes: Routes = [
  {
    path: '',
    component: SupplierAvailabilityDashboardComponent,
    data: { title: 'Supplier Availability' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SupplierAvailabilityDashboardRoutingModule {}

@NgModule({
  declarations: [SupplierAvailabilityDashboardComponent],
  imports: [
    SupplierAvailabilityDashboardRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SupplierAvailabilityDashboardModule {}
